package app.nestbridge.app.usecase

import com.karawek.core.auth.model.Passkey
import com.karawek.core.auth.usecase.GetAvailableAuthMethodsUseCase
import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.coroutines.SuspendSettings
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

/**
 * Drives the one-time "set up a passkey?" prompt shown after a user is
 * authenticated. Prompts at most once (persisted flag), and only where passkeys
 * are actually supported. Manual enrollment from Settings also marks it prompted
 * so the user isn't nagged afterward.
 */
@OptIn(ExperimentalSettingsApi::class)
@Inject
@SingleIn(AppScope::class)
class PasskeyEnrollmentPromptUseCase(
    private val getAvailableAuthMethods: GetAvailableAuthMethodsUseCase,
    private val settings: SuspendSettings,
) {
    suspend fun shouldPrompt(): Boolean {
        if (!getAvailableAuthMethods().contains(Passkey)) return false
        return !settings.getBoolean(KEY, false)
    }

    suspend fun markPrompted() {
        settings.putBoolean(KEY, true)
    }

    private companion object {
        const val KEY = "passkey_enrollment_prompted"
    }
}
